import { render } from "./TransferOwnerShipModal.vue?vue&type=template&id=f520781c&scoped=true"
import script from "./TransferOwnerShipModal.vue?vue&type=script&lang=js"
export * from "./TransferOwnerShipModal.vue?vue&type=script&lang=js"

import "./TransferOwnerShipModal.vue?vue&type=style&index=0&id=f520781c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f520781c"]])

export default __exports__